import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { CART_TYPES, CustomizableMobilePlan, FirebaseUserProfileService, IUserAccount, IUserPlan, MobileCustomPlansServiceNoSync, UserAccountServiceNoSync, UserPlansService } from '@ztarmobile/zwp-service-backend';
import { debounceTime, takeWhile } from 'rxjs';
import { combineLatest } from 'rxjs/operators';
import { ROUTE_URLS, LOGIN_ROUTE_URLS, SHOP_ROUTE_URLS, ACCOUNT_ROUTE_URLS, ACTIVATION_ROUTE_URLS, SUPPORT_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS } from '../../app/app.routes.names';
import { AppState } from '../../app/app.service';
import { ModalHelper } from 'src/services/modal-helper.service';
import { PhonePipe } from '../pipes/phone.pipe';
import { UserAccountService  as accountService} from '@ztarmobile/zwp-service-backend-v2';
import { AccountHeaderService } from '@app/account/account-header.service';
import { CheckoutService } from '@app/shop/checkout/checkout.service';
import { ContentfulService } from '@services/contentful.service';
import { ATT } from '@app/app.config';
import { ALLOW_ATT_ACTIVATION } from '@env/environment';

@Component({
  selector: 'app-header-main-navbar',
  templateUrl: './header-main-navbar.component.html',
  styleUrls: ['./header-main-navbar.component.scss']
})
export class HeaderMainNavbarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() mdnData: any;
  public menuShowing = false;
  public isLoggedIn = true;
  public subAccountShowing = false;
  public hasCartItem = true;
  public totalItems = 0;
  public activeItem = 0;
  public userCart: CustomizableMobilePlan;
  public loadingPlan = true;
  public selectedPlan: IUserPlan;
  public notificationCounter = 0;
  public ROUTE_URLS = ROUTE_URLS;
  public SHOP_ROUTE_URLS = SHOP_ROUTE_URLS;
  public ACCOUNT_ROUTE_URLS = ACCOUNT_ROUTE_URLS;
  public ACTIVATION_ROUTE_URLS = ACTIVATION_ROUTE_URLS;
  public SUPPORT_ROUTE_URLS = SUPPORT_ROUTE_URLS;
  public PLANS_SHOP_ROUTE_URLS = PLANS_SHOP_ROUTE_URLS;
  public LOGIN_ROUTE_URLS = LOGIN_ROUTE_URLS;
  public innerWidth;
  public displayMaintenanceBanner = false;
  public mantainenceDescription;
  public showMenu: boolean;
  public userHasActivePlans = false;
  public subMenu;
  public userPlans: IUserPlan[];
  public outageBanner = false;
  public syncError: string;
  public ATT = ATT;
  public userHasActiveAttPlans = false;
  public ALLOW_ATT_ACTIVATION = ALLOW_ATT_ACTIVATION;
  
  private maintenanceHideTimeout?: any;
  private timeout: any;
  private alive = false;
  billingRenewalPaid: boolean;
  userAccount: any;

  constructor(
    private renderer: Renderer2,
    private simpleAuthService: SimpleAuthService,
    public router: Router,
    private userPlansService: UserPlansService,
    private appState: AppState,
    private angularAuthService: AngularFireAuth,
    private mobilePlansService: MobileCustomPlansServiceNoSync,
    private userAccountService: UserAccountServiceNoSync,
    private modalHelper: ModalHelper,
    private userAccountServicev2: accountService,
    private userProfileService: FirebaseUserProfileService,
    private accountHeaderService: AccountHeaderService,
    private checkoutService: CheckoutService,
    private contentfulService: ContentfulService) {
  }

  ngOnInit(): void {
    this.getMaintenanceContentFromContentful();
    this.innerWidth = window.innerWidth;
    this.mobilePlansService.currentPlan.pipe(debounceTime(50)).subscribe((plan) => {
      this.hasCartItem = (!!plan && plan.hasPlanItem && plan.cartType !== CART_TYPES.MIGRATION) || (!!plan && plan.simsQuantity > 0 && plan.cartType !== CART_TYPES.MIGRATION) || (!!plan && !!plan.addOns) || (plan.cartType === CART_TYPES.MIGRATION && !plan.eSIM);
      this.calculateCartItems(plan);
      this.getNotificationCount();
    });
    this.simpleAuthService.userState.subscribe((authState) => {
      this.isLoggedIn = !!authState && !authState.isAnonymous;
    });
    this.userProfileService.userProfileObservable.subscribe((user) => {
      if (!!user) {
        this.userPlansService.userPlans.subscribe((plans) => {
          if (!!plans) {
            if (!this.mdnData && !this.selectedPlan?.mdn) { // if the user didn't go direct to account pages then the mdn data will be null and we have to set the selected plan value
              const activePlans =  plans.filter((plan) => !!plan.mdn);
              if (!!activePlans && activePlans.length > 0) {
                this.selectedPlan = activePlans[0];
                // adding timeout until the url is detect correctly 
                setTimeout(() => {
                  this.userPlanSelected(activePlans[0]);
                },2000)
              }
            }
          }
        });
       
      }
    });

  }

  ngOnDestroy(): void {
    this.alive = false;
    clearTimeout(this.maintenanceHideTimeout);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.mdnData && !!changes.mdnData.currentValue) {
      this.selectedPlan = changes.mdnData.currentValue.plan;
      this.userAccount = changes.mdnData.currentValue.account;
      this.loadingPlan = !!changes.mdnData.currentValue.loadingData ? changes.mdnData.currentValue.loadingData : false;
      this.syncError = !!changes.mdnData.currentValue.error ? changes.mdnData.currentValue.error : null;
    }
  }

  public showSubMenu(menu): void {
    this.subMenu = menu === this.subMenu ? null : menu;
  }

  public planCompare(plan1: IUserPlan, plan2: IUserPlan) {
    return !!plan1 && !!plan2 ? plan1.id === plan2.id : plan1 === plan2;
  }

  public userPlanSelected(userPlan: IUserPlan): void {
    this.appState.selectedMdnDetails.next({plan: userPlan});
    const decodedUrl = decodeURIComponent(this.router.url);
    if (!!userPlan && !userPlan.canceled && !userPlan.portInRequestNumber && decodedUrl.indexOf(ACCOUNT_ROUTE_URLS.BASE) < 0) { // if the user is not already in the account page then the sync from activated selector will not be called so I am checking here the url and call sync based on that
      this.loadingPlan = true;
      this.userAccountServicev2.getMdnDetails(this.selectedPlan.id, this.selectedPlan.mdn, 'MDNSIMPLE').then((response) => {
        if (!!response && response.mdn === userPlan.mdn) { // this is added because the user will be able to change the mdn while the other sync is being called and it can show the first mdn details for the new selected one without this condition
          this.loadingPlan = false;
          this.selectedPlan = userPlan;
          this.userAccount = response;
        }
       
      }, (error) => {
        if (!!error) {
          const errorCode = error.error.errors[0].code;
          this.loadingPlan = false;
          this.syncError = error.error.errors[0];
        }
      })
    }
  }

  public toggleMenu(): void {
    if (!!this.showMenu) {
      this.allowScrolling()
    } else {
      this.renderer.addClass(document.body, 'modal-open');
      this.renderer.removeClass(document.body, 'modal-closed');
    }
    this.showMenu = !this.showMenu;
  }

  public allowScrolling(): void {
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
  }

  public toggleShowing(): void {
    this.menuShowing = !this.menuShowing;
    // prevent body from scroll when menu is open
    if (this.menuShowing) {
      this.renderer.addClass(document.body, 'modal-open');
      this.renderer.removeClass(document.body, 'modal-closed');
    } else {
      this.renderer.removeClass(document.body, 'modal-open');
      this.renderer.addClass(document.body, 'modal-closed');
    }
  }

  public goToAccountSummary(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
    this.onLinkClick(event);
  }

  public goToPlans(): void {
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
    this.onLinkClick(event, 'plans');
  }

  public goToPurchasedPlans(): void {
    this.mobilePlansService.setSimCard('');
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.PENDING_ACTIVATIONS}`]);
    this.onLinkClick(event);
  }

  public goToAddOns(): void {
    if (!!this.userAccount && this.userAccount?.accountUpdatable && !this.userAccount.pastDue && !!this.selectedPlan && !this.selectedPlan.portInRequestNumber) {
      this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.PLAN_ADD_ONS}`]);
    }
    this.onLinkClick(event);
  }

  public changePlan(): void {
    if (!!this.selectedPlan && !this.selectedPlan.portInRequestNumber && !this.selectedPlan.canceled && (this.userAccount && !this.userAccount.billingRenewalPaid && this.userAccount?.accountUpdatable)) {
      if (!!this.userCart && !!this.userCart.cartType && this.userCart.cartType !== CART_TYPES.CHANGE_PLAN) {
        // eslint-disable-next-line max-len
        this.modalHelper.showConfirmMessageModal('Clear Cart', 'Purchasing a plan will remove any other item in your cart. Do you want to proceed?', 'Yes', 'No', 'clean-cart-modal')
          .afterClosed().subscribe((result) => {
            if (result) {
              this.mobilePlansService.clearUserCart();
              this.appState.clearSessionStorage();
              const params = {};
              params[ROUTE_URLS.PARAMS.USER_PLAN_ID] = this.selectedPlan.id;
              this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.CHANGE_PLAN}`, params]);
            }
          }, (error) => {
            console.error('error', error);
          });
      } else {
        const params = {};
        params[ROUTE_URLS.PARAMS.USER_PLAN_ID] = this.selectedPlan.id;
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.CHANGE_PLAN}`, params]);
      }

    }
  }

  public goToOrders(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.ORDERS}`]);
    this.onLinkClick(event);
  }

  public goToPaymentHistory(): void {
    if (!this.selectedPlan?.portInRequestNumber) {
      this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.PAYMENTS}`]);
    }
    this.onLinkClick(event);
  }

  public goToUsageHistory(): void {
    if (!this.selectedPlan?.portInRequestNumber) {
      this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.USAGE}`]);
    }
    this.onLinkClick(event);
  }

  public goToManageDevice(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.MANAGE_DEVICES}`]);
    this.onLinkClick(event);
  }

  public goToProfile(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SETTINGS}`]);
    this.onLinkClick(event);
  }

  public logout(event): void {
    this.menuShowing = false;
    this.setActiveItem(0);
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
    this.router.navigate([ROUTE_URLS.HOME]);
    this.appState.clearSessionStorage();
    this.appState.selectedMdnDetails.next(null);
    this.angularAuthService.signOut();
    this.appState.userLoggedIn.next(undefined);
    this.appState.selectedMdnDetails.next(null);
    this.accountHeaderService.setMdnInfo(null);
    sessionStorage.removeItem('sessionId');
    this.clearAccountStorage();
    this.checkoutService.setPayments({ card: { address1: '', address2: '', cardCode: '', cardNumber: '', last4: '', id: '', city: '', state: '', country: '', postalCode: '', method: '', name: '', alias: '', fullName: '', brand: '' } });
  }

  private clearAccountStorage(): void {
    sessionStorage.removeItem('nextPaymentPaid');
    sessionStorage.removeItem('futureDetails');
    sessionStorage.removeItem('disabledAccountBanner');
    sessionStorage.removeItem('expiredAccountBanner');
    sessionStorage.removeItem('futurePlan');
    sessionStorage.removeItem('setupeSim');
    sessionStorage.removeItem('swapeSIM');
    sessionStorage.removeItem('replacementSim');
    sessionStorage.removeItem('planCancellation');
    sessionStorage.removeItem('setupPlan');
    sessionStorage.removeItem('actionRequired');
    sessionStorage.removeItem('revertCancellation');
    sessionStorage.removeItem('portInBanner');
    sessionStorage.removeItem('trialBanner');
    sessionStorage.removeItem('upgradeBanner');
    sessionStorage.removeItem('disabledAccountBanner');
    sessionStorage.removeItem('expiredAccountBanner');
  }

  public goToQuickTopUp(): void {
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
    this.menuShowing = false;
    this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.MDN_QUICK_TOP_UP}`]);
  }

  public homeClick(): void {
    this.menuShowing = false;
    this.router.navigate([ROUTE_URLS.HOME]);
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
  }

  public goToCart(): void {
    if (this.hasCartItem && !(this.router.url.indexOf('cart') > -1)) {
      this.menuShowing = false;
      this.renderer.removeClass(document.body, 'modal-open');
      this.renderer.addClass(document.body, 'modal-closed');
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
    }
  }

  public onLinkClick(event, page?: string): void {
    // const activeLink = event.toElement.getAttribute('routerlinkactive');
    const screenWidth = window.innerWidth;
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
    if (screenWidth < 1400) {
      this.toggleShowing();
    }
    if (!!page && (page === 'plans')) {
      this.mobilePlansService.setSimCard('');
    }
  }

  public toggleMenuAccount(): void {
    this.subAccountShowing = !this.subAccountShowing;
  }

  public setActiveItem(x: number): void {
    this.resetTimeout();
    this.activeItem = x;
  }

  public resetTimeout(): void {
    if (!!this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  public calculateCartItems(plan): void {
    this.totalItems = 0;
    if (!!plan) {
      if (!!plan.cartType && plan.cartType !== CART_TYPES.PLAN_ITEMS) {
        this.totalItems = 1;
      } else {
        if (plan.addOns) {
          this.totalItems += plan.addOns.length;
        }
        if (plan.simsQuantity) {
          this.totalItems += 1;
        }
      }
    }
  }

  public getSelectorTitle(plan: IUserPlan): string {
    const mdn: string = (new PhonePipe()).transform(plan.mdn);
    const title = !!plan.portInRequestNumber ? `PortIn for ${mdn}` : mdn;
    return title;
  }

  public getNotificationCount(): void {
    if (!!this.isLoggedIn) {
      this.userAccountService.userAccounts.pipe(combineLatest(this.userPlansService.userPlans, (accounts: IUserAccount[], plans) => {
        const userAccounts = accounts.filter((account) => account.billingRenewDaysLeft <= 3);
        let pendingPlans: IUserPlan[];
        let activePlans: IUserPlan[];
        if (!!plans) {
          activePlans = plans.filter((plan) => !!plan.mdn);
          pendingPlans = plans.filter((plan) => !plan.mdn);
          this.userPlans = activePlans;
          this.userHasActivePlans = (!!activePlans && activePlans.length > 0);
        }
        if (userAccounts.length > 0) {
          this.notificationCounter = 1;
        } else {
          this.notificationCounter = pendingPlans.length;
        }
      }), takeWhile(() => this.alive)).subscribe();
    }
  }

  private getMaintenanceContentFromContentful(): void {
  this.contentfulService.getContent('maintenanceModel').subscribe(contents => {
    if (!contents?.length) return;
    const result = contents[0].fields;
    this.mantainenceDescription =
      this.contentfulService.getRichTextWithOptions(result.maintenanceDescription);

    const maxDate = new Date(result.endDisplayDate);
    const displayDate = new Date(result.maintenanceDisplayDate);
    const now = new Date();

    this.displayMaintenanceBanner = now >= displayDate && now < maxDate;
    if (this.displayMaintenanceBanner) {
      const msUntilHide = maxDate.getTime() - now.getTime();

      this.maintenanceHideTimeout = setTimeout(() => {
        this.displayMaintenanceBanner = false;
      }, msUntilHide);
    }
  });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 1399) {
      this.showMenu = false;
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event): void {
    this.menuShowing = false;
    this.renderer.removeClass(document.body, 'modal-open');
    this.renderer.addClass(document.body, 'modal-closed');
  }
}
